import styled from 'styled-components'

export const CatalogItemContentStyled = styled.div`
  padding: ${(props) => props.theme.space.small};
`
